import { render, staticRenderFns } from "./MultiRegionPicker.vue?vue&type=template&id=5c5e3106&scoped=true"
import script from "./MultiRegionPicker.vue?vue&type=script&lang=ts"
export * from "./MultiRegionPicker.vue?vue&type=script&lang=ts"
import style0 from "./MultiRegionPicker.vue?vue&type=style&index=0&id=5c5e3106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5e3106",
  null
  
)

export default component.exports